import MsJSClient from '@wolfejs/ms-api-js/src';
import { FundsBank } from '@wolfejs/ms-api-js/src/types/fundsBank';
import type { BalanceInfo } from '@wolfejs/ms-ui/Funds/types';

export async function getFundsBank(client: MsJSClient): Promise<undefined | FundsBank> {
  try {
    const { data: response } = await client.myaccount.getFunds();
    const data = response.data[0];
    return data;
  } catch (error) {
    console.error(error);
    return;
  }
}
export async function getFundsId(client: MsJSClient): Promise<undefined | string> {
  try {
    const { data: response } = await client.myaccount.getFunds();
    const { uuid: id } = response.data[0];
    return id;
  } catch (error) {
    console.error(error);
    return;
  }
}
export async function getFundsDetails(client: MsJSClient): Promise<Partial<BalanceInfo> | undefined | string> {
  try {
    const { data: response } = await client.myaccount.getFunds();
    const { actual_balance: balance, uuid: id } = response.data[0];
    if (!id) return;
    return { amount: balance };
  } catch (error) {
    console.error(error);
    return;
  }
}
